// extracted by css-extract-rspack-plugin
export default {"page":"styles-module__page__rWNbgiR","subnav":"styles-module__subnav__prKlqbC"};